import { render, staticRenderFns } from "./property-results.vue?vue&type=template&id=15a3e228&scoped=true&"
import script from "./property-results.vue?vue&type=script&lang=ts&"
export * from "./property-results.vue?vue&type=script&lang=ts&"
import style0 from "./property-results.vue?vue&type=style&index=0&id=15a3e228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a3e228",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VPagination,VProgressCircular})
